module.exports = __webpack_public_path__ + "static/img/8.35a5b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8.png
// module id = I6fH
// module chunks = 13